import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "components/loader";
import { useGetInTouchLocation } from "hooks/Forms/useGetInTouchLocation";
import ThankYouPopup from "components/popup/thankYouPopup";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";

export default function LocationBanner({ title, content, backgroundCol, formOrangeHead, formWhiteHead, p, bName }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { status, mutateAsync } = useGetInTouchLocation();

  const onSubmit = (data) => {
    const postData = {
      name: data.name,
      email: data.email,
      message: data.message,
      pagelink: location.href,
    };
    mutateAsync(postData).then((_) => {
      reset();
      setOpen(true);
    });
  };
  return (
    <div className={`${backgroundCol ? backgroundCol : "bg-location-banner"} bg-cover bg-no-repeat bg-center flex items-center justify-center`}>
      <div className="mainContainer w-[90%] flex flex-wrap lg:flex-nowrap xl:w-9/12 2xl:w-[1170px]  justify-between items-center text-white pt-5 pb-[60px] px-6 2xl:px-6 xl:pl-0 xl:-ml-5 2xl:ml-0">
        <div className="textContent text-white md:w-11/12 lg:w-7/12 w-full flex flex-col ">
          <div className="text">
            <h1 className="text-40 leading-[50px] font-secondary font-bold mb-[1.5rem]  max-w-[545px]" dangerouslySetInnerHTML={{ __html: title }} />

            <p className="mb-[1.5rem] font-opensans leading-[1.6] max-w-[545px]">{content}</p>
          </div>
          <div className="btn">
            <Link to="/quote" className="bg-orange hover:bg-hoverYellow rounded-3xl w-[180px] flex items-center justify-center h-[40px] font-semibold text-sm font-opensans">
              {bName ? bName : "TRANSLATE NOW"}
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-0 lg:gap-2 xl:gap-0 mt-5 font-opensans text-md">
            <div className="flex flex-row">
              <img className="w-4" src="https://tomedes.gumlet.io/frontend/images/location-template/badge.svg" alt="" />
              <p className="ml-1">1 Year Guarantee |</p>
            </div>
            <div className="flex flex-row">
              <img className="w-[22px]" src="https://tomedes.gumlet.io/frontend/images/location-template/call-center.svg" alt="" />
              <p className="ml-1">24/7 Availability |</p>
            </div>
            <div className="flex flex-row">
              <img className="w-[22px]" src="https://tomedes.gumlet.io/frontend/images/location-template/16-express.svg" alt="" />
              <p className="ml-1">Fast Delivery</p>
            </div>
          </div>
        </div>
        <ThankYouPopup open={open} setOpen={setOpen} />
        <div className="form border-white bg-locationFormBorder  justify-center min-h-[415px] xl:min-h-[443px]  max-w-[380px] min-w-300 py-4 xl:py-8  px-6 mt-4 ml-0 2xl:mr-[69px] xl:mr-[21px]">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="inputs flex flex-col mx-auto justify-center text-black  max-w-max">
              <h2 className="text-2xl font-bold pb-4 font-secondary mt-[14px]">
                <span className="text-orange">{formOrangeHead}</span> {formWhiteHead}
              </h2>
              <p className=" font-opensans pb-4 mb-[10px]">{p ? p : "Get in touch with us in real-time, any time."}</p>
              <input
                type="text"
                placeholder="Name"
                name="name"
                className={`${errors.name ? "border-red" : "border-borderGray"} outline-none font-opensans border  rounded pl-3 py-1 mb-5`}
                {...register("name", {
                  required: true,
                })}
              />
              {errors.name && <span className="text-red text-sm font-primary mb-[10px] mt-[-16px]">This field is required</span>}
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                className={`${errors.email ? "border-red" : "border-borderGray"} font-opensans outline-none border rounded pl-3 py-1 mb-5`}
                {...register("email", {
                  required: true,
                })}
              />

              {errors.email && <span className="text-red text-sm font-primary  mb-[10px] mt-[-16px]">This field is required</span>}
              <textarea
                className={`${errors.message ? "border-red" : "border-borderGray"} font-opensans outline-none border rounded  pl-3 py-1 mb-5`}
                name="message"
                cols="30"
                rows="2"
                placeholder="Tell us more about your needs"
                {...register("message")}
              ></textarea>
              {errors.message && <span className="text-red text-sm font-primary mb-[10px] mt-[-16px]">This field is required</span>}

              <button type="submit" className="bg-orange py-2 text-center font-secondary font-extrabold  text-white bannerform_submit">
                {status === "loading" ? <Loader /> : "SUBMIT"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
